// eslint-disable-next-line import/no-default-export -- deprecated usage
export { default } from "./FormSelect";
export type { FormSelectProps } from "./FormSelect";
